import UiForm from "./UiForm";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import UiGroup from "./UiGroup";

/**
 * 贸易条款表单
 * @description 自动生成的代码,请勿修改
 */
export default class DtoFormTradeTerms extends UiForm<string> {
    constructor() {
        //无参构造函数
        super()
        this.UiGroups = [];
    }

    [proName: string]: any;
    /**
     * 中文名称
     */
    Name?: string;
    /**
     * 英文名称
     */
    NameEn?: string;
    /**
     * 英文简写
     */
    Code?: string;
    /**
     * 全名
     */
    FullName?: string;
    /**
     * 注释
     */
    Remark?: string;
    /**
     * 对应的成交方式
     */
    TransactionModeId?: string;
}

/**
 * 贸易条款表单-表单校验
 */
export const DtoFormTradeTermsRules = {
    Name: [
        {
            required: true,
            message: "信息不能为空",
            trigger: "blur",
        },
        {
            max: 128,
            message: "文本长度不能超过 128 个字符",
            trigger: "blur",
        },
    ],
    NameEn: [
        {
            max: 128,
            message: "文本长度不能超过 128 个字符",
            trigger: "blur",
        },
    ],
    Code: [
        {
            max: 128,
            message: "文本长度不能超过 128 个字符",
            trigger: "blur",
        },
    ],
    FullName: [
        {
            max: 10240,
            message: "文本长度不能超过 10240 个字符",
            trigger: "blur",
        },
    ],
    Remark: [
        {
            max: 10240,
            message: "文本长度不能超过 10240 个字符",
            trigger: "blur",
        },
    ],
    TransactionModeId: [
        {
            required: true,
            message: "信息不能为空",
            trigger: "change",
        },
    ],
}

/**
 * 贸易条款表单-设置项
 */
export const DtoFormTradeTermsMiezzFormItems: MiezzFormItem[] = [
  {
    Prop: "Name",
    Label: "中文名称",
    Customize: true,
  },
  {
    Prop: "NameEn",
    Label: "英文名称",
    Customize: true,
  },
  {
    Prop: "Code",
    Label: "英文简写",
    Customize: true,
  },
  {
    Prop: "FullName",
    Label: "全名",
    Customize: true,
  },
  {
    Prop: "Remark",
    Label: "注释",
    Type: EnumMiezzFormItemType.AreaText,
  },
  {
    Prop: "TransactionModeId",
    Label: "对应的成交方式",
    Customize: true,
  },
]
